module.exports = __webpack_public_path__ + "media/images/icons/flags/PG-bc4dce5508bb23eeceb97b5dcdcb9877.svg";